// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__zGA0Y","signatureBlock":"Footer_signatureBlock__ooICV","signature":"Footer_signature__AEQPs"};